import { render, staticRenderFns } from "./StudentQuizAnswer.vue?vue&type=template&id=d8f64d5e"
import script from "./StudentQuizAnswer.vue?vue&type=script&lang=js"
export * from "./StudentQuizAnswer.vue?vue&type=script&lang=js"
import style0 from "./StudentQuizAnswer.vue?vue&type=style&index=0&id=d8f64d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports